import Numeral from 'numeral'
import { isNumber } from 'lodash-es'

const defaultMetricValues = {
  companyJobCount: 'N/A',
  carrierCount: 'N/A',
  companyJobDocumentCount: 'N/A',
  companyJobMilesDrivenSum: 'N/A',
  companyJobRateSum: 'N/A',
  milestoneCompletionAverage: 'N/A'
}

export default {
  data() {
    return {
      metrics: {}
    }
  },

  created() {
    this.resetMetrics()
  },

  methods: {
    resetMetrics() {
      this.metrics = Object.assign({}, defaultMetricValues)
    },

    formatNumber(num) {
      if (isNumber(num)) {
        return Numeral(num).format('0,0')
      } else {
        return 'N/A'
      }
    },

    formatCurrency(num) {
      if (isNumber(num)) {
        return Numeral(num).format('$0,0.00')
      } else {
        return 'N/A'
      }
    },

    formatPercent(num) {
      if (isNumber(num)) {
        return Numeral(num / 100).format('0%')
      } else {
        return 'N/A'
      }
    }
  }
}
